(async () => {
    if (!customElements.get("scrolling-promotion")) {
        class ScrollingPromotion extends HTMLElement {
            constructor() {
                super();
                console.log('[SP] constructor fired');
                this.config = {
                    moveTime: parseFloat(this.dataset.speed),
                    space: 100,
                };
                this.promotion = this.querySelector('.promotion');
                console.log('[SP] promotion el:', this.promotion);
            }

            connectedCallback() {
                console.log('[SP] connectedCallback fired');
                console.log('[SP] childElementCount:', this.childElementCount);
                console.log('[SP] promotion:', this.promotion);
                this.init();
            }

            init() {
                console.log('[SP] init fired, childElementCount:', this.childElementCount);
                if (this.childElementCount === 1) {
                    console.log('[SP] condition passed, starting clone process');
                    this.promotion.classList.add('promotion--animated');

                    const images = Array.from(this.promotion.querySelectorAll('img'));
                    console.log('[SP] images found:', images.length);
                    
                    const imagePromises = images.map(img => {
                        // Force remove lazy loading so Safari doesn't block load events
                        img.removeAttribute('loading');
                        if (img.complete && img.naturalWidth > 0) return Promise.resolve();
                        return new Promise(resolve => {
                            img.addEventListener('load', resolve, { once: true });
                            img.addEventListener('error', resolve, { once: true });
                            // Safari fallback — if no event fires in 2s, proceed anyway
                            setTimeout(resolve, 2000);
                        });
                    });

                    Promise.all(imagePromises).then(() => {
                        console.log('[SP] all images ready');
                        requestAnimationFrame(() => {
                            console.log('[SP] rAF fired');
                            setTimeout(() => {
                                console.log('[SP] setTimeout fired');
                                const items = this.promotion.querySelectorAll('.promotion__item');
                                console.log('[SP] items found:', items.length);
                                
                                items.forEach(item => {
                                    const w = item.getBoundingClientRect().width;
                                    console.log('[SP] item width:', w);
                                    item.style.width = w + 'px';
                                });

                                for (let index = 0; index < 10; index++) {
                                    this.clone = this.promotion.cloneNode(true);
                                    this.clone.setAttribute('aria-hidden', true);
                                    this.appendChild(this.clone);
                                }

                                console.log('[SP] childElementCount after clone:', this.childElementCount);

                                const animationTimeFrame = Math.max((this.promotion.clientWidth / this.config.space) * this.config.moveTime, 26);
                                console.log('[SP] animationTimeFrame:', animationTimeFrame);
                                this.style.setProperty('--duration', `${animationTimeFrame}s`);

                                const observer = new IntersectionObserver((entries, _observer) => {
                                    entries.forEach(entry => {
                                        if (entry.isIntersecting) {
                                            this.scrollingPlay();
                                        } else {
                                            this.scrollingPause();
                                        }
                                    });
                                }, { rootMargin: '0px 0px 50px 0px' });

                                observer.observe(this);
                            }, 0);
                        });
                    });
                } else {
                    console.log('[SP] condition FAILED — childElementCount is not 1');
                }
            }

            scrollingPlay() {
                this.classList.remove('scrolling-promotion--paused');
            }

            scrollingPause() {
                this.classList.add('scrolling-promotion--paused');
            }
        }

        window.ScrollingPromotion = ScrollingPromotion;
        customElements.define("scrolling-promotion", ScrollingPromotion);
    }
})();